export const UPDATE = "GLOBAL_FILTER.UPDATE";
